import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnDownload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="M3 15.472v3.351c0 1.132.917 2.049 2.048 2.049h13.904A2.05 2.05 0 0 0 21 18.823v-3.351M11.99 3.128v13.244m-5.405-5.05 5.4 5.4 5.4-5.4"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnDownload;
